module.exports = __webpack_public_path__ + "img/collections@2x.a82bbb6.webp";